










import { defineComponent } from '@vue/composition-api';
import LazyHydrate from 'vue-lazy-hydration';

export default defineComponent({
  name: 'LegalPageWrapper',
  components: {
    LazyHydrate,
  },
});
